import { useMemo } from 'react';

import { sanitizeAgentText } from '../lib/formatters';
import type {
  UseAssistantMessageTextParams,
  UseAssistantMessageTextReturn,
} from '../types/hooks';

export function useAssistantMessageText({
  text,
}: UseAssistantMessageTextParams): UseAssistantMessageTextReturn {
  const sanitizedText = useMemo(() => sanitizeAgentText(text), [text]);

  // Extract plain text for fallback rendering when HTML sanitization removes all content.
  const plainText = useMemo(
    () =>
      sanitizedText
        .replace(/<br\s*\/?\s*>/gi, '\n')
        .replace(/<[^>]+>/g, '')
        .trim(),
    [sanitizedText],
  );

  // Business rule: Render HTML only if sanitized text contains visible content.
  // Fallback to plain text if sanitization removed everything but original had content.
  const shouldRenderHtml = plainText.length > 0;
  const shouldRender = plainText.length > 0 || sanitizedText.trim().length > 0;

  return {
    sanitizedText,
    plainText,
    shouldRenderHtml,
    shouldRender,
  };
}
